/*
 * Copyright (C) 2026 to Present Applause App Quality, Inc. All rights reserved.
 */

import {
  ChangeDetectionStrategy, Component, Input,
} from '@angular/core';
import { ProjectNavigationService } from '../project-navigation.service';

// A project in a board list: the shared community feed card, with the badges, start date and countries it has no place for.
@Component({
  selector: 'ut-project-card',
  templateUrl: './project-card.component.html',
  styleUrls: ['./project-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ProjectCardComponent {
  @Input({ required: true }) project: any;
  // The FeedStore this card is listed in, for Previous / Next on the project page.
  @Input() feed: any;

  constructor(private navigation: ProjectNavigationService) {}

  open(): void {
    if (this.feed) this.navigation.feed = this.feed;
  }
}
